import React from 'react';
import { motion } from 'framer-motion';
import { Cloud, Server, Cpu, Zap } from 'lucide-react';
import Spline from '@splinetool/react-spline';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <Cloud size={40} />,
      title: 'SaaS Solutions',
      description: 'Scalable software-as-a-service platforms built for modern businesses with enterprise-grade security and reliability.',
      features: ['Multi-tenant Architecture', 'Auto-scaling', 'API-first Design']
    },
    {
      icon: <Server size={40} />,
      title: 'Cloud Native',
      description: 'Container-orchestrated applications designed for cloud environments with microservices architecture and DevOps integration.',
      features: ['Kubernetes Native', 'Microservices', 'Cloud Agnostic']
    },
    {
      icon: <Zap size={40} />,
      title: 'DevOps Excellence',
      description: 'Streamlined CI/CD pipelines, infrastructure as code, and automated deployment strategies for faster delivery.',
      features: ['CI/CD Automation', 'Infrastructure as Code', 'Monitoring & Observability']
    },
    {
      icon: <Cpu size={40} />,
      title: 'GPU Computing',
      description: 'High-performance computing solutions leveraging GPU acceleration for AI, ML, and data-intensive workloads.',
      features: ['CUDA Optimization', 'Distributed Computing', 'AI/ML Acceleration']
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="section-header"
        >
          <h2 className="section-title">
            Our <span className="gradient-text">Core Services</span>
          </h2>
          <p className="section-description">
            Comprehensive technology solutions designed to accelerate your digital transformation
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="spline-container"
        >
          <Spline scene="https://prod.spline.design/7YY5tfP5Qlu5mhOa/scene.splinecode" />
        </motion.div>

        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="service-card"
            >
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
